import React, { useCallback, useState } from 'react';
import _get from 'lodash/get';

// Components
import AddAttribute from 'components/BuildAttribute/AddAttribute';
import AttributeInputForm from 'components/BuildAttribute/AttributeInputForm';
import AttributeRadioForm from 'components/BuildAttribute/AttributeRadioForm';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';
import { defineStyles, Classes } from 'styles/defineStyles';

import { PERSON_ENTITY_TYPE_KEY } from 'helpers/useEntityTypes';

const styles = defineStyles(theme => {
  return {
    dialogPaper: {
      minWidth: 500,
    },
    cancelButton: {
      marginRight: theme.spacing(1),
    },
  };
});

interface Props {
  onCreate: (newAttribute: NewAttribute) => void;

  // container
  isCreateAttributeDialogOpen: boolean;
  createCategoryField: (attribute: any) => any;
  toggleCreateAttributeDialog: () => any;

  // HOC
  classes: Classes<typeof styles>;
}

interface NewAttribute {
  category: string | 0; // 0 is for the unselected field
  displayName: string;
  entityField: string;
  baseField: string;
  type: string;
}

const initialState: NewAttribute = {
  category: 0,
  displayName: '',
  entityField: PERSON_ENTITY_TYPE_KEY,
  baseField: '',
  type: '',
};

function CreatedAttributeDialog(props: Props) {
  const {
    onCreate,
    // Connector
    isCreateAttributeDialogOpen,
    createCategoryField,
    toggleCreateAttributeDialog,
    classes, // HOC
  } = props;

  const [disableSubmit, setDisableSubmit] = useState(false);
  const [newAttribute, setNewAttribute] = useState(initialState);

  const handleChangeAttribute = useCallback(
    (value: any) => {
      setNewAttribute({
        ...newAttribute,
        ...value,
      });
    },
    [newAttribute],
  );

  // Handle Submit
  const handleSubmitAttribute = async () => {
    setDisableSubmit(true);
    const { body } = await createCategoryField(newAttribute);

    // HACK Jules: once we can use async with fetches, this will not be a problem.
    setTimeout(() => {
      onCreate(body);
      toggleCreateAttributeDialog();
      setDisableSubmit(false);
    }, 200);
  };

  return (
    <Dialog open={isCreateAttributeDialogOpen} classes={{ paper: classes.dialogPaper }}>
      <DialogTitle>Create an Attribute</DialogTitle>
      <DialogContent>
        <AddAttribute onChange={handleChangeAttribute} />
        {!!newAttribute.baseField && (
          <>
            <AttributeInputForm onChange={handleChangeAttribute} attribute={newAttribute} />
            <AttributeRadioForm onChange={handleChangeAttribute} attribute={newAttribute} />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleCreateAttributeDialog} className={classes.cancelButton}>
          Cancel
        </Button>
        <Button
          color="secondary"
          onClick={handleSubmitAttribute}
          disabled={!newAttribute.displayName || disableSubmit}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(CreatedAttributeDialog);
